import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { heroSlides } from "@/mocks/hero";

export default function HeroCarousel() {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const total = heroSlides.length;

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % total);
    }, 5500);
    return () => window.clearInterval(timer);
  }, [total]);

  const goTo = (target: number) => setIndex((target + total) % total);
  const current = heroSlides[index];

  return (
    <section className="relative w-full h-[440px] md:h-[600px] overflow-hidden bg-foreground-950">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            title={`${slide.title} - 樱桃视频精选`}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/60 to-foreground-950/20"></div>
        </div>
      ))}

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-4 md:px-8">
          <div key={current.id} className="max-w-2xl cherry-fade-up">
            <span className="inline-block rounded-full bg-primary-500 px-3 py-1 text-xs font-label text-background-50">
              {current.badge}
            </span>
            <h1 className="mt-4 text-3xl md:text-5xl font-heading font-bold text-background-50 leading-tight">
              {current.title}
            </h1>
            <p className="mt-3 md:mt-4 text-sm md:text-base leading-relaxed text-background-200 max-w-xl">
              {current.subtitle}
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <button
                type="button"
                onClick={() => navigate(`/detail/${current.videoId}`)}
                className="flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-base"></i>
                查看详情
              </button>
              <button
                type="button"
                onClick={() => navigate("/category/net-movie")}
                className="flex items-center gap-2 rounded-md border border-background-100/40 px-5 py-2.5 text-sm font-label text-background-50 hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-base"></i>
                浏览分类
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* arrows */}
      <button
        type="button"
        aria-label="上一张"
        onClick={() => goTo(index - 1)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-foreground-950/40 text-background-50 hover:bg-primary-500 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => goTo(index + 1)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-foreground-950/40 text-background-50 hover:bg-primary-500 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      {/* dots */}
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {heroSlides.map((slide, i) => (
          <button
            key={slide.id}
            type="button"
            aria-label={`切换到第 ${i + 1} 张`}
            onClick={() => goTo(i)}
            className={`h-2 rounded-full transition-all cursor-pointer ${
              i === index ? "w-7 bg-primary-500" : "w-2 bg-background-100/60 hover:bg-background-100"
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}